export default __webpack_public_path__ + "static/media/metamask1.9687957d.png";